angular.module('shared').directive('logItemValue', function() {
  return {
    restrict: 'E',
    scope: {
      value: '='
    },
    template: require('templates/shared/log_item_value.html.slim'),
    controller: ["$scope", function($scope) {
      var ref, ref1;
      return $scope.isColor = ((ref = $scope.value) != null ? ref[0] : void 0) === '#' && ((ref1 = $scope.value.length) === 4 || ref1 === 7);
    }]
  };
});
